// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"677":"d8e6ce57","814":"1ba55748"}[chunkId] + ".chunk.js";
};